import { Facebook, Instagram, MessageCircle, MessageSquareText, MousePointerClick, Phone } from "lucide-react";
import "./badge.css"

const SOURCE_META = {
  Chat: { icon: MessageCircle, label: "Chat", className: "source-chat" },
  Activity: { icon: MousePointerClick, label: "Activity", className: "source-activity" },
  Call: { icon: Phone, label: "Call", className: "source-call" },
  Facebook: { icon: Facebook, label: "Facebook", className: "source-facebook", isMeta: true },
  Instagram: { icon: Instagram, label: "Instagram", className: "source-instagram", isMeta: true },
  WhatsApp: { icon: MessageSquareText, label: "WhatsApp", className: "source-whatsapp", isMeta: true },
};

export default function SourceBadges({ sources = [], isAdLead = false }) {
  if (!sources.length) {
    return <span className="source-capsule source-capsule-empty">—</span>;
  }

  return (
    <div className="source-capsule">
      {sources.map((key, idx) => {
        const meta = SOURCE_META[key];
        if (!meta) return null;
        const Icon = meta.icon;
        return (
          <span
            key={key}
            className={`source-row ${meta.className} ${idx > 0 ? "source-row-divided" : ""}`}
          >
            <Icon size={11} strokeWidth={2.25} />
            <span className="source-label">{meta.label}</span>
            {meta.isMeta && isAdLead && <span className="source-ad-tag">Ad</span>}
          </span>
        );
      })}
    </div>
  );
}
